export enum GridSize {
  large = 'LARGE',
  regular = 'REGULAR',
}
